module.exports = __webpack_public_path__ + "static/media/Toucannon_gaussian2.d97bd349.png";